export default __webpack_public_path__ + "media/images/cta_blocks/hotels_finder-6b448a4accd75736120fbf5196e71b7f.jpg";